import react from 'react';
import Logo from "../Assests/images/Logo 4.png";


const Video = () => {
    return (
        <div className="video-navbar-container mb-10">
            <img src={Logo} alt="Logo" className='video-navbar-logo' />
            <div className='video-Content'>
                <div style={{ textAlign: 'center' }}>
                    <div className='video-heading'>
                        Diabetes / Pre-diabetes CLINICAL Study
                    </div>
                </div>

                <div className='video-subheading'>
                    Instruction For CGM
                </div>
                <div className='video-Content'>
                    <video width="640" height="360" controls>
                        <source
                            src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Sinocare+iCan+i3+CGM+-Instruction+Video+1.mp4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div className='video-subheading'>
                    Instruction For Stool Sample Collection
                </div>

                <div className='video-Content'>
                    <video width="450" height="250" controls>
                        <source
                            src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Stool+collection+video+B2_12062025.MP4"
                            type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className='blood-urine-instructions-container' style={{ marginTop: '30px', padding: '0 20px' }}>
                    <div className='video-subheading' style={{ marginBottom: '15px' }}>
                        Instructions for Clinical Study Participants: (Blood and Urine Sample Collection)
                    </div>
                    <div className='blood-urine-content' style={{ textAlign: 'left' }}>
                        <h4>A. Before Breakfast Blood Sample Collection :</h4>
                        <ul>
                            <li>Participants are advised not to eat or drink anything except plain water for 8–12 hours before the test, preferably finishing dinner before 10PM is recommended.</li>
                            <li>Avoid caffeine or exercise during fasting.</li>
                            <li>The sample collection will done between 6 AM -7 AM at your home on a scheduled date as per your convenience by the lab.</li>
                            <li>Drink a small amount of plain water in the morning if needed (avoid dehydration).</li>
                        </ul>

        
                        <h4>B. Urine Sample Collection : </h4>
                        <ul>
                            <li>Participants will be asked to provide a urine sample along with their fasting blood sample collection.</li>
                            <li>It is recommended to retain the first morning urine, as it is often preferred for better diagnostic accuracy.</li>
                            <li>Drinking a moderate amount of water (1–2 glasses) about 1 hour before your visit is advised to ensure you can comfortably provide a sample.</li>
                        </ul>
                    </div>
                </div>

                <div className='ogtt-instructions-container' style={{ marginTop: '20px', padding: '0 20px' }}>
                    <div className='video-subheading' style={{ marginBottom: '15px' }}>
                        Instruction for Oral Glucose Tolerance Test (OGTT) with Continuous Glucose Monitoring (CGM)
                    </div>
                    <div className='ogtt-content' style={{ textAlign: 'left' }}>
                        <h4>1. Participant Pre-Test Instructions</h4>
                        <p style={{ fontStyle: 'italic', marginTop: '5px', marginBottom: '10px' }}>Participants must adhere to the following for accurate and reproducible results:</p>

                        <h6>Diet & Activity (Prior to Test Week)</h6>
                        <ul>
                            <li>Perform the OGTT during a typical week (no restrictive or celebratory eating such as holidays, weddings, or fasting periods). </li>
                            <li>Maintain normal dietary habits (do not alter macronutrient intake). </li>
                            <li>Maintain usual physical activity levels (no unusual exertion or training routines). </li>
                        </ul>

                        <h6>24 Hours Prior to Test</h6>
                        <ul>
                            <li>No strenuous exercise after 5:00 PM. </li>
                            <li>Avoid eating out to control for unknown dietary variables. </li>
                        </ul>

                        <h6>Evening Before the Test</h6>
                        <ul>
                            <li>Do not eat or drink (except water) after 10:00 PM. </li>
                            <li>Avoid alcohol, caffeine, smoking, or nicotine patches. </li>
                        </ul>

                        <h6>Morning of the Test</h6>
                        <ul>
                            <li>Remain fasted (no caloric intake); only plain water is allowed. </li>
                            <li>Do not smoke or use nicotine. </li>
                        </ul>

                        <h4>2. When to perform</h4>
                        <p style={{ marginLeft: '20px' }}>On day 2 and day 4
                            at 6am </p>

                        <h4>3. Test Day Protocol</h4>
                        <h5>Preparation</h5>
                        <ul>
                            <li>Verify CGM is properly placed and actively recording.</li>
                            <li>Ensure a calm environment with a place to remain seated for at least 3 hours. </li>
                        </ul>

                        <h5>Start of Test</h5>
                        <ul>
                            <li>Begin the test in the morning after an overnight fast of 8-12 hours. </li>
                            <li>Consume one packet of the given Glucose diluted in 300ml of water. </li>
                            <li>Drink the entire solution within 5 minutes. </li>
                        </ul>

                        <h5>Post-Glucose Monitoring</h5>
                        <ul>
                            <li>No food or caloric beverage intake for the next 3 hours. </li>
                            <li>Only plain water is permitted. </li>
                            <li>Remain seated and physically inactive during the entire 3-hour monitoring period. </li>
                        </ul>

                        <h5>CGM Recording</h5>
                        <ul>
                            <li>Ensure CGM is continuously collecting data throughout the test. </li>
                            <li>No sensor calibrations, disconnections, or restarts should be performed during the 3-hour window.</li>
                        </ul>
                    </div>
                </div>





            </div>
        </div>
    )
}
export default Video;